import { fr, enUS } from 'date-fns/locale';
// eslint-disable-next-line no-restricted-imports
import i18next from 'i18next';

export const getDateFnsLocale = () => (i18next.language === 'en' ? enUS : fr);
